import {RelInstallParametreModel} from './RelInstallParametre.model';
import {InstallLogModel} from './InstallLog.model';

export class InstallModel {
    public idInstall: string;
    public nom: string;
    public nbBasesAutorisees: number;
    public expiration: string;
    public numeroClient: string;
    public activation: string;
    public nbJourUtilisation: number;
    public nbCredits: number;
    public creeLe: string;
    public modifieLe: Date;
    public installLog: InstallLogModel;
    public isFitcheck: boolean;
    public relInstall: RelInstallParametreModel;
    public nbBases: number;
    public idAccount: string;

    constructor() {
    }
}
